import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

export function useUnread(user) {
  const [unread, setUnread] = useState(0);
  const [adminOpen, setAdminOpen] = useState(0);
  const loc = useLocation();

  useEffect(() => {
    if (!user) { setUnread(0); setAdminOpen(0); return; }
    const load = () => {
      api.get("/support/unread").then(({ data }) => setUnread(data.count)).catch(() => {});
      if (user.role === "admin") api.get("/admin/support/unread").then(({ data }) => setAdminOpen(data.count)).catch(() => {});
    };
    load();
    const iv = setInterval(load, 15000);
    window.addEventListener("jp-unread", load);
    return () => { clearInterval(iv); window.removeEventListener("jp-unread", load); };
  }, [user?.id, user?.role, loc.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return { unread, adminOpen };
}

export const Badge = ({ n }) =>
  n > 0 ? (
    <span className="absolute -top-2 -right-3 min-w-[18px] h-[18px] px-1 rounded-full bg-red-600 text-white text-[10px] font-bold flex items-center justify-center animate-pulse" data-testid="unread-badge">{n}</span>
  ) : null;
